import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, Suite, test } from 'vest'

import { ConsentFormData as FormData } from './Consent'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
  shouldAskHealthInfoProcessing: boolean,
): Suite<string, string, (data: FormData, changedFields?: FieldName<FormData>[]) => void> => {
  return create((data) => {
    omitWhen(!shouldAskHealthInfoProcessing, () => {
      test('consentHealthDataProcessing', formatMessage({ id: 'validate-required-field-missing' }), () => {
        enforce(data.consentHealthDataProcessing).equals(true)
      })
    })

    test('confirmInformationAccuracy', () => {
      test('confirmInformationAccuracy', formatMessage({ id: 'validate-required-field-missing' }), () => {
        enforce(data.confirmInformationAccuracy).equals(true)
      })
    })
  })
}
